function helperGetDateMonth (date) {
  return date.getMonth()
}

module.exports = helperGetDateMonth



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperGetDateMonth.js
// module id = dA88
// module chunks = 141